/** @returns {string[]} */
export function normalizeMultiSelectValue(value) {
  if (Array.isArray(value)) {
    return value.map(String);
  }
  if (value === undefined || value === null || value === '') {
    return [];
  }
  return String(value)
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
}
